import { shadowTypes } from "../styles/UnitShadow";
import BaseURL from "./images/Hosting-BaseURL";

const goblin1AImage = `${BaseURL}/Martial/Goblins/Goblin 1 A.png`;
const goblin1BImage = `${BaseURL}/Martial/Goblins/Goblin 1 B.png`;
const goblin1CImage = `${BaseURL}/Martial/Goblins/Goblin 1 C.png`;
const goblin1DImage = `${BaseURL}/Martial/Goblins/Goblin 1 D.png`;
const goblin1EImage = `${BaseURL}/Special/Christmas/Goblin 1 E.png`;
const goblin1BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 1 B.png`;
const goblin1CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 1 C.png`;
const goblin1DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 1 D.png`;
const goblin1EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 1 E.png`;

const goblin2AImage = `${BaseURL}/Martial/Goblins/Goblin 2 A.png`;
const goblin2BImage = `${BaseURL}/Martial/Goblins/Goblin 2 B.png`;
const goblin2CImage = `${BaseURL}/Martial/Goblins/Goblin 2 C.png`;
const goblin2DImage = `${BaseURL}/Martial/Goblins/Goblin 2 D.png`;
const goblin2EImage = `${BaseURL}/Special/Christmas/Goblin 2 E.png`;
const goblin2BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 2 B.png`;
const goblin2CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 2 C.png`;
const goblin2DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 2 D.png`;
const goblin2EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 2 E.png`;

const goblin3AImage = `${BaseURL}/Martial/Goblins/Goblin 3 A.png`;
const goblin3BImage = `${BaseURL}/Martial/Goblins/Goblin 3 B.png`;
const goblin3CImage = `${BaseURL}/Martial/Goblins/Goblin 3 C.png`;
const goblin3DImage = `${BaseURL}/Martial/Goblins/Goblin 3 D.png`;
const goblin3EImage = `${BaseURL}/Special/Christmas/Goblin 3 E.png`;
const goblin3BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 3 B.png`;
const goblin3CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 3 C.png`;
const goblin3DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 3 D.png`;
const goblin3EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 3 E.png`;

const goblin4AImage = `${BaseURL}/Martial/Goblins/Goblin 4 A.png`;
const goblin4BImage = `${BaseURL}/Martial/Goblins/Goblin 4 B.png`;
const goblin4CImage = `${BaseURL}/Martial/Goblins/Goblin 4 C.png`;
const goblin4DImage = `${BaseURL}/Martial/Goblins/Goblin 4 D.png`;
const goblin4EImage = `${BaseURL}/Special/Christmas/Goblin 4 E.png`;
const goblin4BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 4 B.png`;
const goblin4CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 4 C.png`;
const goblin4DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 4 D.png`;
const goblin4EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 4 E.png`;

const goblin5AImage = `${BaseURL}/Martial/Goblins/Goblin 5 A.png`;
const goblin5BImage = `${BaseURL}/Martial/Goblins/Goblin 5 B.png`;
const goblin5CImage = `${BaseURL}/Martial/Goblins/Goblin 5 C.png`;
const goblin5DImage = `${BaseURL}/Martial/Goblins/Goblin 5 D.png`;
const goblin5EImage = `${BaseURL}/Special/Christmas/Goblin 5 E.png`;
const goblin5BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 5 B.png`;
const goblin5CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 5 C.png`;
const goblin5DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 5 D.png`;
const goblin5EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 5 E.png`;

const goblin6AImage = `${BaseURL}/Martial/Goblins/Goblin 6 A.png`;
const goblin6BImage = `${BaseURL}/Martial/Goblins/Goblin 6 B.png`;
const goblin6CImage = `${BaseURL}/Martial/Goblins/Goblin 6 C.png`;
const goblin6DImage = `${BaseURL}/Martial/Goblins/Goblin 6 D.png`;
const goblin6EImage = `${BaseURL}/Special/Christmas/Goblin 6 E.png`;
const goblin6BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 6 B.png`;
const goblin6CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 6 C.png`;
const goblin6DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 6 D.png`;
const goblin6EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 6 E.png`;

const goblin7AImage = `${BaseURL}/Martial/Goblins/Goblin 7 A.png`;
const goblin7BImage = `${BaseURL}/Martial/Goblins/Goblin 7 B.png`;
const goblin7CImage = `${BaseURL}/Martial/Goblins/Goblin 7 C.png`;
const goblin7DImage = `${BaseURL}/Martial/Goblins/Goblin 7 D.png`;
const goblin7EImage = `${BaseURL}/Special/Christmas/Goblin 7 E.png`;
const goblin7BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 7 B.png`;
const goblin7CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 7 C.png`;
const goblin7DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 7 D.png`;
const goblin7EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 7 E.png`;

const goblin8AImage = `${BaseURL}/Martial/Goblins/Goblin 8 A.png`;
const goblin8BImage = `${BaseURL}/Martial/Goblins/Goblin 8 B.png`;
const goblin8CImage = `${BaseURL}/Martial/Goblins/Goblin 8 C.png`;
const goblin8DImage = `${BaseURL}/Martial/Goblins/Goblin 8 D.png`;
const goblin8EImage = `${BaseURL}/Special/Christmas/Goblin 8 E.png`;
const goblin8BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 8 B.png`;
const goblin8CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 8 C.png`;
const goblin8DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 8 D.png`;
const goblin8EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 8 E.png`;

const goblin9AImage = `${BaseURL}/Martial/Goblins/Goblin 9 A.png`;
const goblin9BImage = `${BaseURL}/Martial/Goblins/Goblin 9 B.png`;
const goblin9CImage = `${BaseURL}/Martial/Goblins/Goblin 9 C.png`;
const goblin9DImage = `${BaseURL}/Martial/Goblins/Goblin 9 D.png`;
const goblin9EImage = `${BaseURL}/Special/Christmas/Goblin 9 E.png`;
const goblin9BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 9 B.png`;
const goblin9CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 9 C.png`;
const goblin9DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 9 D.png`;
const goblin9EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 9 E.png`;

const goblin10AImage = `${BaseURL}/Martial/Goblins/Goblin 10 A.png`;
const goblin10BImage = `${BaseURL}/Martial/Goblins/Goblin 10 B.png`;
const goblin10CImage = `${BaseURL}/Martial/Goblins/Goblin 10 C.png`;
const goblin10DImage = `${BaseURL}/Martial/Goblins/Goblin 10 D.png`;
const goblin10EImage = `${BaseURL}/Special/Christmas/Goblin 10 E.png`;
const goblin10BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 10 B.png`;
const goblin10CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 10 C.png`;
const goblin10DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 10 D.png`;
const goblin10EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 10 E.png`;

const goblin11AImage = `${BaseURL}/Martial/Goblins/Goblin 11 A.png`;
const goblin11BImage = `${BaseURL}/Martial/Goblins/Goblin 11 B.png`;
const goblin11CImage = `${BaseURL}/Martial/Goblins/Goblin 11 C.png`;
const goblin11DImage = `${BaseURL}/Martial/Goblins/Goblin 11 D.png`;
const goblin11EImage = `${BaseURL}/Special/Christmas/Goblin 11 E.png`;
const goblin11BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 11 B.png`;
const goblin11CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 11 C.png`;
const goblin11DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 11 D.png`;
const goblin11EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 11 E.png`;

const goblin12AImage = `${BaseURL}/Martial/Goblins/Goblin 12 A.png`;
const goblin12BImage = `${BaseURL}/Martial/Goblins/Goblin 12 B.png`;
const goblin12CImage = `${BaseURL}/Martial/Goblins/Goblin 12 C.png`;
const goblin12DImage = `${BaseURL}/Martial/Goblins/Goblin 12 D.png`;
const goblin12EImage = `${BaseURL}/Special/Christmas/Goblin 12 E.png`;
const goblin12BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 12 B.png`;
const goblin12CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 12 C.png`;
const goblin12DPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 12 D.png`;
const goblin12EPreviewImage = `${BaseURL}/Special/Christmas/previews/Goblin 12 E.png`;

const mountedGoblin13AImage = `${BaseURL}/Martial/Goblins/Mounted Goblin 13 A.png`;
const mountedGoblin13BImage = `${BaseURL}/Special/Christmas/Mounted Goblin 13.png`;
const mountedGoblin13BPreviewImage = `${BaseURL}/Special/Christmas/previews/Mounted Goblin 13.png`;

const mountedGoblin14AImage = `${BaseURL}/Martial/Goblins/Mounted Goblin 14 A.png`;
const mountedGoblin14BImage = `${BaseURL}/Special/Christmas/Mounted Goblin 14.png`;
const mountedGoblin14BPreviewImage = `${BaseURL}/Special/Christmas/previews/Mounted Goblin 14.png`;

const mountedGoblin15AImage = `${BaseURL}/Martial/Goblins/Mounted Goblin 15 A.png`;
const mountedGoblin15BImage = `${BaseURL}/Special/Christmas/Mounted Goblin 15.png`;
const mountedGoblin15BPreviewImage = `${BaseURL}/Special/Christmas/previews/Mounted Goblin 15.png`;

const mountedGoblin16AImage = `${BaseURL}/Martial/Goblins/Mounted Goblin 16 A.png`;
const mountedGoblin16BImage = `${BaseURL}/Special/Christmas/Mounted Goblin 16.png`;
const mountedGoblin16BPreviewImage = `${BaseURL}/Special/Christmas/previews/Mounted Goblin 16.png`;

const goblin17AImage = `${BaseURL}/Martial/Goblins/Goblin 17 A.png`;
const goblin17BImage = `${BaseURL}/Martial/Goblins/Goblin 17 B.png`;
const goblin17CImage = `${BaseURL}/Martial/Goblins/Goblin 17 C.png`;
const goblin17BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 17 B.png`;
const goblin17CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 17 C.png`;

const goblin18AImage = `${BaseURL}/Martial/Goblins/Goblin 18 A.png`;
const goblin18BImage = `${BaseURL}/Martial/Goblins/Goblin 18 B.png`;
const goblin18CImage = `${BaseURL}/Martial/Goblins/Goblin 18 C.png`;
const goblin18BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 18 B.png`;
const goblin18CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 18 C.png`;

const goblin19AImage = `${BaseURL}/Martial/Goblins/Goblin 19 A.png`;
const goblin19BImage = `${BaseURL}/Martial/Goblins/Goblin 19 B.png`;
const goblin19CImage = `${BaseURL}/Martial/Goblins/Goblin 19 C.png`;
const goblin19BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 19 B.png`;
const goblin19CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 19 C.png`;

const goblin20AImage = `${BaseURL}/Martial/Goblins/Goblin 20 A.png`;
const goblin20BImage = `${BaseURL}/Martial/Goblins/Goblin 20 B.png`;
const goblin20CImage = `${BaseURL}/Martial/Goblins/Goblin 20 C.png`;
const goblin20BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 20 B.png`;
const goblin20CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 20 C.png`;

const goblin21AImage = `${BaseURL}/Martial/Goblins/Goblin 21 A.png`;
const goblin21BImage = `${BaseURL}/Martial/Goblins/Goblin 21 B.png`;
const goblin21CImage = `${BaseURL}/Martial/Goblins/Goblin 21 C.png`;
const goblin21BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 21 B.png`;
const goblin21CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 21 C.png`;

const goblin22AImage = `${BaseURL}/Martial/Goblins/Goblin 22 A.png`;
const goblin22BImage = `${BaseURL}/Martial/Goblins/Goblin 22 B.png`;
const goblin22CImage = `${BaseURL}/Martial/Goblins/Goblin 22 C.png`;
const goblin22BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 22 B.png`;
const goblin22CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 22 C.png`;

const goblin23AImage = `${BaseURL}/Martial/Goblins/Goblin 23 A.png`;
const goblin23BImage = `${BaseURL}/Martial/Goblins/Goblin 23 B.png`;
const goblin23CImage = `${BaseURL}/Martial/Goblins/Goblin 23 C.png`;
const goblin23BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 23 B.png`;
const goblin23CPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 23 C.png`;

const goblin24AImage = `${BaseURL}/Martial/Goblins/Goblin 24 A.png`;
const goblin24BImage = `${BaseURL}/Martial/Goblins/Goblin 24 B.png`;
const goblin24BPreviewImage = `${BaseURL}/Martial/Goblins/previews/Goblin 24 B.png`;

export default [
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "24px",
            right: "61px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "1",
                filePrefix: "Goblin",
                src: goblin1AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "1",
                filePrefix: "Goblin",
                src: goblin1BImage,
                previewSrc: goblin1BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "cleaver",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "1",
                filePrefix: "Goblin",
                src: goblin1CImage,
                previewSrc: goblin1CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "leather",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "1",
                filePrefix: "Goblin",
                src: goblin1DImage,
                previewSrc: goblin1DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "cloth",
                    "blue",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "1",
                filePrefix: "Goblin",
                src: goblin1EImage,
                previewSrc: goblin1EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "20px",
            right: "75px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "2",
                filePrefix: "Goblin",
                src: goblin2AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "2",
                filePrefix: "Goblin",
                src: goblin2BImage,
                previewSrc: goblin2BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "2",
                filePrefix: "Goblin",
                src: goblin2CImage,
                previewSrc: goblin2CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "axe",
                    "leather",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "2",
                filePrefix: "Goblin",
                src: goblin2DImage,
                previewSrc: goblin2DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "cloth",
                    "blue",
                    "eyepatch",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "2",
                filePrefix: "Goblin",
                src: goblin2EImage,
                previewSrc: goblin2EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "22px",
            right: "63px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "3",
                filePrefix: "Goblin",
                src: goblin3AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "3",
                filePrefix: "Goblin",
                src: goblin3BImage,
                previewSrc: goblin3BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "3",
                filePrefix: "Goblin",
                src: goblin3CImage,
                previewSrc: goblin3CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "3",
                filePrefix: "Goblin",
                src: goblin3DImage,
                previewSrc: goblin3DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "bow",
                    "ranged",
                    "cloth",
                    "blue",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "3",
                filePrefix: "Goblin",
                src: goblin3EImage,
                previewSrc: goblin3EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "bow",
                    "ranged",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "16px",
            right: "64px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "4",
                filePrefix: "Goblin",
                src: goblin4AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "axe",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "4",
                filePrefix: "Goblin",
                src: goblin4BImage,
                previewSrc: goblin4BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "cleaver",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "4",
                filePrefix: "Goblin",
                src: goblin4CImage,
                previewSrc: goblin4CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "cleaver",
                    "leather",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "4",
                filePrefix: "Goblin",
                src: goblin4DImage,
                previewSrc: goblin4DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "dagger",
                    "cloth",
                    "blue",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "4",
                filePrefix: "Goblin",
                src: goblin4EImage,
                previewSrc: goblin4EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "axe",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "16px",
            right: "57px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "5",
                filePrefix: "Goblin",
                src: goblin5AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "5",
                filePrefix: "Goblin",
                src: goblin5BImage,
                previewSrc: goblin5BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "green",
                ],
            },
            {
                variant: "C",
                unitNumber: "5",
                filePrefix: "Goblin",
                src: goblin5CImage,
                previewSrc: goblin5CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "red",
                ],
            },
            {
                variant: "D",
                unitNumber: "5",
                filePrefix: "Goblin",
                src: goblin5DImage,
                previewSrc: goblin5DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "cloth",
                    "blue",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "5",
                filePrefix: "Goblin",
                src: goblin5EImage,
                previewSrc: goblin5EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "13px",
            right: "43px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "6",
                filePrefix: "Goblin",
                src: goblin6AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "spear",
                    "leather",
                    "green",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "6",
                filePrefix: "Goblin",
                src: goblin6BImage,
                previewSrc: goblin6BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "sword",
                    "leather",
                    "green",
                    "animal",
                    "wolf",
                    "grey",
                ],
            },
            {
                variant: "C",
                unitNumber: "6",
                filePrefix: "Goblin",
                src: goblin6CImage,
                previewSrc: goblin6CPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "spear",
                    "leather",
                    "red",
                    "animal",
                    "wolf",
                    "grey",
                ],
            },
            {
                variant: "D",
                unitNumber: "6",
                filePrefix: "Goblin",
                src: goblin6DImage,
                previewSrc: goblin6DPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "spear",
                    "cloth",
                    "blue",
                    "animal",
                    "wolf",
                    "grey",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "6",
                filePrefix: "Goblin",
                src: goblin6EImage,
                previewSrc: goblin6EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "weapon",
                    "spear",
                    "leather",
                    "christmas",
                    "red",
                    "animal",
                    "wolf",
                    "brown",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "17px",
            right: "51px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "7",
                filePrefix: "Goblin",
                src: goblin7AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bow",
                    "sword",
                    "ranged",
                    "leather",
                    "eyepatch",
                ],
            },
            {
                variant: "B",
                unitNumber: "7",
                filePrefix: "Goblin",
                src: goblin7BImage,
                previewSrc: goblin7BPreviewImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bow",
                    "sword",
                    "ranged",
                    "armor",
                    "eyepatch",
                ],
            },
            {
                variant: "C",
                unitNumber: "7",
                filePrefix: "Goblin",
                src: goblin7CImage,
                previewSrc: goblin7CPreviewImage,
                tags: [
                    "goblin",
                    "red",
                    "weapon",
                    "bow",
                    "sword",
                    "ranged",
                    "leather",
                    "eyepatch",
                ],
            },
            {
                variant: "D",
                unitNumber: "7",
                filePrefix: "Goblin",
                src: goblin7DImage,
                previewSrc: goblin7DPreviewImage,
                tags: [
                    "goblin",
                    "blue",
                    "weapon",
                    "bow",
                    "sword",
                    "ranged",
                    "leather",
                    "eyepatch",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "7",
                filePrefix: "Goblin",
                src: goblin7EImage,
                previewSrc: goblin7EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bow",
                    "sword",
                    "ranged",
                    "leather",
                    "eyepatch",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "14px",
            right: "42px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "8",
                filePrefix: "Goblin",
                src: goblin8AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bomb",
                    "torch",
                    "cloth",
                ],
            },
            {
                variant: "B",
                unitNumber: "8",
                filePrefix: "Goblin",
                src: goblin8BImage,
                previewSrc: goblin8BPreviewImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bomb",
                    "torch",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "8",
                filePrefix: "Goblin",
                src: goblin8CImage,
                previewSrc: goblin8CPreviewImage,
                tags: [
                    "goblin",
                    "red",
                    "weapon",
                    "bomb",
                    "torch",
                    "cloth",
                ],
            },
            {
                variant: "D",
                unitNumber: "8",
                filePrefix: "Goblin",
                src: goblin8DImage,
                previewSrc: goblin8DPreviewImage,
                tags: [
                    "goblin",
                    "blue",
                    "weapon",
                    "bomb",
                    "torch",
                    "cloth",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "8",
                filePrefix: "Goblin",
                src: goblin8EImage,
                previewSrc: goblin8EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "bomb",
                    "torch",
                    "ranged",
                    "cloth",
                    "red",
                    "christmas",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "12px",
            right: "55px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "9",
                filePrefix: "Goblin",
                src: goblin9AImage,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "magic",
                    "weapon",
                    "staff",
                ],
            },
            {
                variant: "B",
                unitNumber: "9",
                filePrefix: "Goblin",
                src: goblin9BImage,
                previewSrc: goblin9BPreviewImage,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "magic",
                    "weapon",
                    "staff",
                ],
            },
            {
                variant: "C",
                unitNumber: "9",
                filePrefix: "Goblin",
                src: goblin9CImage,
                previewSrc: goblin9CPreviewImage,
                tags: [
                    "goblin",
                    "red",
                    "cloth",
                    "magic",
                    "weapon",
                    "staff",
                    "black",
                ],
            },
            {
                variant: "D",
                unitNumber: "9",
                filePrefix: "Goblin",
                src: goblin9DImage,
                previewSrc: goblin9DPreviewImage,
                tags: [
                    "goblin",
                    "blue",
                    "cloth",
                    "magic",
                    "weapon",
                    "staff",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "9",
                filePrefix: "Goblin",
                src: goblin9EImage,
                previewSrc: goblin9EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "magic",
                    "weapon",
                    "staff",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "18px",
            right: "44px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "10",
                filePrefix: "Goblin",
                src: goblin10AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "dart",
                    "ranged",
                    "cloth",
                ],
            },
            {
                variant: "B",
                unitNumber: "10",
                filePrefix: "Goblin",
                src: goblin10BImage,
                previewSrc: goblin10BPreviewImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "dart",
                    "ranged",
                    "cloth",
                ],
            },
            {
                variant: "C",
                unitNumber: "10",
                filePrefix: "Goblin",
                src: goblin10CImage,
                previewSrc: goblin10CPreviewImage,
                tags: [
                    "goblin",
                    "red",
                    "weapon",
                    "dart",
                    "ranged",
                    "cloth",
                ],
            },
            {
                variant: "D",
                unitNumber: "10",
                filePrefix: "Goblin",
                src: goblin10DImage,
                previewSrc: goblin10DPreviewImage,
                tags: [
                    "goblin",
                    "blue",
                    "weapon",
                    "dart",
                    "ranged",
                    "cloth",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "10",
                filePrefix: "Goblin",
                src: goblin10EImage,
                previewSrc: goblin10EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "dart",
                    "ranged",
                    "cloth",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "22px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "11",
                filePrefix: "Goblin",
                src: goblin11AImage,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "weapon",
                    "bow",
                    "ranged",
                    "eyepatch",
                ],
            },
            {
                variant: "B",
                unitNumber: "11",
                filePrefix: "Goblin",
                src: goblin11BImage,
                previewSrc: goblin11BPreviewImage,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "weapon",
                    "bow",
                    "ranged",
                    "eyepatch",
                ],
            },
            {
                variant: "C",
                unitNumber: "11",
                filePrefix: "Goblin",
                src: goblin11CImage,
                previewSrc: goblin11CPreviewImage,
                tags: [
                    "goblin",
                    "red",
                    "cloth",
                    "weapon",
                    "bow",
                    "ranged",
                    "eyepatch",
                ],
            },
            {
                variant: "D",
                unitNumber: "11",
                filePrefix: "Goblin",
                src: goblin11DImage,
                previewSrc: goblin11DPreviewImage,
                tags: [
                    "goblin",
                    "blue",
                    "cloth",
                    "weapon",
                    "bow",
                    "ranged",
                    "eyepatch",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "11",
                filePrefix: "Goblin",
                src: goblin11EImage,
                previewSrc: goblin11EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "cloth",
                    "weapon",
                    "bow",
                    "ranged",
                    "eyepatch",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "21px",
            right: "48px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "12",
                filePrefix: "Goblin",
                src: goblin12AImage,
                tags: [
                    "goblin",
                    "cloth",
                    "green",
                    "magic",
                    "purple",
                ],
            },
            {
                variant: "B",
                unitNumber: "12",
                filePrefix: "Goblin",
                src: goblin12BImage,
                previewSrc: goblin12BPreviewImage,
                tags: [
                    "goblin",
                    "cloth",
                    "green",
                    "magic",
                    "purple",
                ],
            },
            {
                variant: "C",
                unitNumber: "12",
                filePrefix: "Goblin",
                src: goblin12CImage,
                previewSrc: goblin12CPreviewImage,
                tags: [
                    "goblin",
                    "cloth",
                    "red",
                    "magic",
                    "purple",
                ],
            },
            {
                variant: "D",
                unitNumber: "12",
                filePrefix: "Goblin",
                src: goblin12DImage,
                previewSrc: goblin12DPreviewImage,
                tags: [
                    "goblin",
                    "cloth",
                    "blue",
                    "magic",
                    "purple",
                    "pirate",
                ],
            },
            {
                variant: "E",
                unitNumber: "12",
                filePrefix: "Goblin",
                src: goblin12EImage,
                previewSrc: goblin12EPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "cloth",
                    "green",
                    "magic",
                    "purple",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "22px",
            right: "38px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "13",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin13AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "sword",
                    "animal",
                    "boar",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "13",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin13BImage,
                previewSrc: mountedGoblin13BPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "sword",
                    "animal",
                    "boar",
                    "brown",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "13px",
            right: "41px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "14",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin14AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "axe",
                    "animal",
                    "boar",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "14",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin14BImage,
                previewSrc: mountedGoblin14BPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "axe",
                    "animal",
                    "boar",
                    "brown",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "12px",
            right: "27px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "15",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin15AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "sword",
                    "animal",
                    "boar",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "15",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin15BImage,
                previewSrc: mountedGoblin15BPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "sword",
                    "animal",
                    "boar",
                    "brown",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "22px",
            right: "27px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "16",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin16AImage,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "mace",
                    "animal",
                    "boar",
                    "brown",
                ],
            },
            {
                variant: "B",
                unitNumber: "16",
                filePrefix: "Mounted Goblin",
                src: mountedGoblin16BImage,
                previewSrc: mountedGoblin16BPreviewImage,
                legendary: true,
                tags: [
                    "goblin",
                    "green",
                    "weapon",
                    "mace",
                    "animal",
                    "boar",
                    "brown",
                    "christmas",
                    "red",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "12px",
            right: "42px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "17",
                filePrefix: "Goblin",
                src: goblin17AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "red",
                ],
            },
            {
                variant: "B",
                unitNumber: "17",
                filePrefix: "Goblin",
                src: goblin17BImage,
                previewSrc: goblin17BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "17",
                filePrefix: "Goblin",
                src: goblin17CImage,
                previewSrc: goblin17CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "14px",
            right: "48px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "18",
                filePrefix: "Goblin",
                src: goblin18AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                ],
            },
            {
                variant: "B",
                unitNumber: "18",
                filePrefix: "Goblin",
                src: goblin18BImage,
                previewSrc: goblin18BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "18",
                filePrefix: "Goblin",
                src: goblin18CImage,
                previewSrc: goblin18CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "13px",
            right: "53px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "19",
                filePrefix: "Goblin",
                src: goblin19AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "purple",
                ],
            },
            {
                variant: "B",
                unitNumber: "19",
                filePrefix: "Goblin",
                src: goblin19BImage,
                previewSrc: goblin19BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "19",
                filePrefix: "Goblin",
                src: goblin19CImage,
                previewSrc: goblin19CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "14px",
            right: "55px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "20",
                filePrefix: "Goblin",
                src: goblin20AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "blue",
                ],
            },
            {
                variant: "B",
                unitNumber: "20",
                filePrefix: "Goblin",
                src: goblin20BImage,
                previewSrc: goblin20BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "20",
                filePrefix: "Goblin",
                src: goblin20CImage,
                previewSrc: goblin20CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "18px",
            right: "47px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "21",
                filePrefix: "Goblin",
                src: goblin21AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "orange",
                ],
            },
            {
                variant: "B",
                unitNumber: "21",
                filePrefix: "Goblin",
                src: goblin21BImage,
                previewSrc: goblin21BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "21",
                filePrefix: "Goblin",
                src: goblin21CImage,
                previewSrc: goblin21CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.SMALL,
            bottom: "-6px",
            right: "45px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "22",
                filePrefix: "Goblin",
                src: goblin22AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "yellow",
                ],
            },
            {
                variant: "B",
                unitNumber: "22",
                filePrefix: "Goblin",
                src: goblin22BImage,
                previewSrc: goblin22BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "22",
                filePrefix: "Goblin",
                src: goblin22CImage,
                previewSrc: goblin22CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.MEDIUM,
            bottom: "8px",
            right: "55px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "23",
                filePrefix: "Goblin",
                src: goblin23AImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "purple",
                ],
            },
            {
                variant: "B",
                unitNumber: "23",
                filePrefix: "Goblin",
                src: goblin23BImage,
                previewSrc: goblin23BPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "treasure",
                ],
            },
            {
                variant: "C",
                unitNumber: "23",
                filePrefix: "Goblin",
                src: goblin23CImage,
                previewSrc: goblin23CPreviewImage,
                tags: [
                    "goblin",
                    "dice",
                    "green",
                    "weapon",
                    "bomb",
                ],
            },
        ]
    },
    {
        shadowDetails: {
            size: shadowTypes.LARGE,
            bottom: "3px",
            right: "25px",
        },
        variants: [
            {
                variant: "A",
                unitNumber: "24",
                filePrefix: "Goblin",
                src: goblin24AImage,
                tags: [
                    "goblin",
                    "weapon",
                    "staff",
                    "magic",
                    "cloth",
                    "dice",
                    "green",
                    "purple",
                ],
            },
            {
                variant: "B",
                unitNumber: "24",
                filePrefix: "Goblin",
                src: goblin24BImage,
                previewSrc: goblin24BPreviewImage,
                tags: [
                    "goblin",
                    "weapon",
                    "staff",
                    "magic",
                    "cloth",
                    "green",
                    "purple",
                ],
            },
        ]
    },
];
